<div class="dialog-header">
  <span class="spacer"></span>
  <span class="header-label">Request Shipping Charge Estimate</span>
  <span class="spacer"></span>
  <button matButton="elevated" class="close-dialog-button warn-button" (click)="cancel()">
    X
  </button>
</div>
@if (errorMessage()) {
  <div class="errorMessage">
    {{ errorMessage() }}
  </div>
}
@if (salesEntity) {
  <div class="content">
    <div class="content-header">
      {{
        'If this ' + salesEntity.id.entityName.toLowerCase() + ' has all required units to be furnished by '
        + salesEntity.brandID + ', please request a shipping charge estimate.  This process will freeze this '
        + salesEntity.id.entityName.toLowerCase() + ' while we obtain the shipping charge estimate.'
        + '  If you believe you have more units to add, then please cancel this request'
      }}
    </div>
    <div class="entity-detail">
      <div class="display-row">
        <span class="display-label">Entity ID:</span>
        <span class="value-label">{{ salesEntity.id.entityId }}</span>
      </div>
      <div class="display-row">
        <span class="display-label">Project Name:</span>
        <span class="value-label">{{ salesEntity.projectName }}</span>
      </div>
      <div class="display-row">
        <span class="display-label">PO Number:</span>
        <span class="value-label">{{ salesEntity.repPo }}</span>
      </div>
      <div class="display-row">
        <span class="display-label">Rep Office:</span>
        <span class="value-label">{{ repOffice()?.description || 'Unknown' }}</span>
      </div>
      <div class="display-row">
        <span class="display-label">Rep Salesman:</span>
        <span class="value-label">{{ salesRep()?.description || 'Unknown' }}</span>
      </div>
      <div class="display-row">
        <span class="display-label">Rep E-mail:</span>
        <span class="value-label">{{ salesRep()?.emailAddress?.emailAddress || 'Unknown' }}</span>
      </div>
      <div class="display-row">
        <span class="display-label">Rep Phone:</span>
        <span class="value-label">{{ salesRep()?.defaultPhoneNumber || 'Unknown' }}</span>
      </div>
      <div class="display-row">
        <span class="display-label">Number of Units:</span>
        <span class="value-label">{{ getConfiguredQuantity() }}</span>
      </div>
      <div class="display-row">
        <span class="display-label">Ship To Address:</span>
        <div class="address-value">
          <div class="address-line">{{ salesEntity.overrideShipToAddressLine1 }}</div>
          <div class="address-line">{{ salesEntity.overrideShipToAddressLine2 }}</div>
          <div class="address-line">{{ salesEntity.overrideShipToCityName + ' ' + salesEntity.overrideShipToStateCode + '  ' + salesEntity.overrideShipToPostalCode }}</div>
          <div class="address-line">{{ salesEntity.overrideShipToCountryCode }}</div>
        </div>
      </div>
    </div>
    <div class="button-container">
      <span class="spacer"></span>
      <button matButton="elevated" class="dialog-button warn-button" (click)="cancel()" [disabled]="isBusy()">Cancel Request</button>
      <button matButton="elevated" class="dialog-button primary-button" (click)="createTask()" [disabled]="isBusy()">Create Request</button>
    </div>
  </div>
}
